/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";

import Label from "./Label";
import { FontWeight, Text } from 'components/Text';
import ValidationError from "./ValidationError";
import CheckBox from "./CheckBox2";
import Colors from 'constants/Colors';
import { isArray } from "lodash";

const alertInputMixin = css`
  box-shadow: 0 0 0 3px ${Colors.SECONDARY1};

  &:focus {
    box-shadow: 0 0 0 3px ${Colors.SECONDARY1};
  }
`;

const CheckboxGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${({ alertField }) => (alertField ? alertInputMixin : '')}
  ${({ row }) => row && `flex-direction: row;`}
`;

const CheckboxLabelContainer = styled.div`
  margin-bottom: 10px;

  ${({ labelVerticalAlign }) => labelVerticalAlign === "top" && `
    height: 100%;
  `}
`;

const CheckboxGroup = ({
  className,
  field,
  fieldName,
  options,
  label,
  isRequired,
  hideLabelAsterisk,
  validation,
  validationMinHeight,
  onChange,
  alertField,
  labelVerticalAlign,
  onlyShowOptionsLabel,
  form: { setFieldValue, status, setFieldTouched, touched, errors },
  ...props }) => {

  const meta = {
    isFocused: status && status[field.name] && status[field.name].isFocused,
    touched: touched[field.name],
    error: errors[field.name]
  };

  const [values, setValues] = useState([]);

  const handleSelect = (value) => {
    const checked = !!values.find(({ idAnswerOption }) => idAnswerOption === value.idAnswerOption);
    let valuesAux = values;
    if (checked) {
      valuesAux = values.filter(({ idAnswerOption }) => idAnswerOption !== value.idAnswerOption)
    } else {
      valuesAux = [...values, value];
    }

    setValues(valuesAux)
    setFieldValue(field.name, valuesAux);
    onChange(valuesAux);
  };

  const handleChecked = (value) => {
    const isChecked = (typeof value === 'object' && value.hasOwnProperty('idAnswerOption'))
      ? values.find(({ idAnswerOption }) => idAnswerOption === value.idAnswerOption)
      : values.includes(value);

    if (value?.idAnswerOption === 16093 && field?.name?.includes('agreementPartiesForContractChanges_136')) {
      console.log("isChecked", !!isChecked, values)
    }
    return !!isChecked;
  };

  useEffect(() => {
    setValues(field.value || []);
  }, [])

  return (
    <>
      {label && (
        <CheckboxLabelContainer labelVerticalAlign={labelVerticalAlign}>
          <Label
            meta={meta}
            isRequired={isRequired}
            weight={FontWeight.Medium}
          >
            {label}
          </Label>
        </CheckboxLabelContainer>
      )}
      <CheckboxGroupContainer {...props} alertField={alertField}>
        {options && options.map((element, index) => (
          <Label horizontalAlign={element?.behaviorObject?.horizontalAlign} key={field.name + index + 'label'} style={{marginBottom: 10}}>
            {!onlyShowOptionsLabel && (
              <CheckBox
                key={field.name + index}
                value={element.value}
                name={field.name}
                checked={handleChecked(element.value)}
                onChange={() => onChange && handleSelect(element.value)}
              />
            )}
            {"   "}{"   "}{element.label}
          </Label>
        ))}
      </CheckboxGroupContainer>
      {validation && (
        <ValidationError
          meta={meta}
          validationMinHeight={validationMinHeight}
        />
      )}
    </>
  );
};

export default CheckboxGroup;